import {
    Container, Spinner
} from "reactstrap";
import React from 'react';
import { useStore } from "../../utilities/appStore";
import ProcessingPaymentModal from "../../components/Modals/ProcessingPaymentModal";

function ProcessingPage() {
    let config = useStore((state) => state.Configuration);
    let currentOrganizationId = useStore((state) => state.CurrentOrganizationId);
    let showSpinner = currentOrganizationId === 0;
    let storeLink = config.ecommerceUrl;
    const routeChange = () => {
        window.location.href = storeLink;
    }

    const styles = {
        header: {
            border: '1px solid',
            backgroundColor: "var(--base-color-gray-background)",
        },
        link: {
            color: "var(--base-color-teal)"
        }
    }
    if (showSpinner) {
        return <Spinner className="centered-loader" />;
    }
    return (
        <Container fluid={true} className="text-center">
            <ProcessingPaymentModal />
        </Container>
    );

}

export default ProcessingPage;